export enum ExternalSystem {
  KlikniJadiLegacy = 1,
  Exelerate = 2,
}
